import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import Popper from "components/Popper";
import { Tooltip } from "@mui/material";
import InfoIcon from "assets/icons/info.svg?react";
import NoteIcon from "assets/icons/sticky-note.svg?react";
import AttachmentsIcon from "assets/icons/attachments.svg?react";
import AttachmentsModal from "../../Modals/AttachmentsModal";
import MetricModal from "../../Modals/MetricModal";
import NotesModal from "../../Modals/NotesModal";

const IconsCell: FC<Props> = ({ onPreview, onDownload, element }) => {
  const { t } = useTranslation();
  const wrapperRef = useRef();

  const [showAttachments, setShowAttachments] = useState(false);
  const [showNotes, setShowNotes] = useState(false);
  const [showInfo, setShowInfo] = useState(false);

  return (
    <div className={styles.icons} ref={wrapperRef}>
      <Tooltip
        title={t("documents.attachments")}
        className={
          element.Attachments?.length ? styles.visible : styles.collapsed
        }
      >
        <div>
          <AttachmentsIcon
            className={classNames(styles.attachments)}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setShowAttachments(!showAttachments);
            }}
          />
        </div>
      </Tooltip>

      <Tooltip
        title={t("notes.title")}
        className={element.NotesCount > 0 ? styles.visible : styles.collapsed}
      >
        <div>
          <NoteIcon
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setShowNotes(!showNotes);
            }}
          />
        </div>
      </Tooltip>

      <Tooltip title={t("metric.title")} className={styles.visible}>
        <div>
          <InfoIcon
            className={classNames(styles.shareIcon)}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setShowInfo(!showInfo);
            }}
          />
        </div>
      </Tooltip>

      {showAttachments && (
        <Popper
          anchorEl={wrapperRef?.current}
          open={showAttachments}
          setOpen={setShowAttachments}
        >
          <AttachmentsModal
            pack={element}
            onDownload={onDownload}
            onPreview={onPreview}
            toggle={() => setShowAttachments(false)}
          ></AttachmentsModal>
        </Popper>
      )}

      {showNotes && (
        <Popper
          anchorEl={wrapperRef?.current}
          open={showNotes}
          setOpen={setShowNotes}
        >
          <NotesModal
            pack={element}
            toggle={() => setShowNotes(false)}
          ></NotesModal>
        </Popper>
      )}

      {showInfo && (
        <Popper
          anchorEl={wrapperRef?.current}
          open={showInfo}
          setOpen={setShowInfo}
        >
          <MetricModal
            addressBookVerificationId={element.Id}
            statuses={[]}
            toggle={() => setShowInfo(false)}
          ></MetricModal>
        </Popper>
      )}
    </div>
  );
};

export default IconsCell;
